export const MESSAGE_ID_QUERY_PARAM = "id"

export function messagesUrlForMessage(messageId?: string): string {
    return messageId
        ? `/notifications?${MESSAGE_ID_QUERY_PARAM}=${encodeURIComponent(messageId)}`
        : "/notifications"
}
